import {
  DateFormat,
  DatePickerInput,
  FAIconName,
  InputGroupV2,
  ValidationMessage,
} from '@equip.health/ui';
import { DateTime } from 'luxon';
import { ValidationType } from '~/lib/constants/enumeration.constants';

type GroupClassDateFieldProps = {
  id: string;
  leftIcon: FAIconName;
  label: string;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;
  minDate?: Date;
  isDisabled?: boolean;
  isRequired?: boolean;
  placeholder?: string;
};

const TOP_LEVEL_ID = 'group-class-date-field';

export const GroupClassDateField = ({
  id,
  leftIcon,
  label,
  value,
  onChange,
  errorMessage,
  minDate,
  isDisabled = false,
  isRequired = true,
  placeholder,
}: GroupClassDateFieldProps) => {
  const handleDateChange = (date: Date) => {
    const dateStr = DateTime.fromJSDate(date).toISODate();

    onChange(dateStr);
  };

  return (
    <InputGroupV2
      id={`${TOP_LEVEL_ID}__${id}`}
      isRequired={isRequired}
      label={label}
      shouldHideOptionalLabel
    >
      <DatePickerInput
        defaultDate={
          value
            ? DateTime.fromFormat(
                value,
                DateFormat.shortYearMonthDay,
              ).toJSDate()
            : undefined
        }
        leftIcon={leftIcon}
        id={`${TOP_LEVEL_ID}__${id}-input`}
        onSubmit={handleDateChange}
        minDate={minDate}
        isDisabled={isDisabled}
        placeholder={placeholder}
      />
      {errorMessage && (
        <ValidationMessage
          id={`${TOP_LEVEL_ID}__${id}-error`}
          type={ValidationType.CRITICAL}
          value={errorMessage}
        />
      )}
    </InputGroupV2>
  );
};
